var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentTab>=0)?_c('iframe',{ref:"frame",staticClass:"iframe",attrs:{"src":_vm.computedUrl,"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }